<template>
    <a :href="href">
        <img src="../assets/rollback.png" height="27" alt="" style="margin-bottom: 5px; margin-left: 15px">
    </a>
</template>

<script setup>
    // icon-fanhui
    import {isLogin} from "../utils/llm.tools";
    const href = isLogin()? '/recent': '/mobile/home'
</script>

